import { isMobile } from 'react-device-detect';
import { screenSm } from 'constants/styles/breakpoints';
import Modal from 'components/modal';
import {
  HeaderContainer,
  ModalActions,
  ModalContainer,
  ModalContent,
  ReportingTitle as Title,
} from 'components/modal/styles';
import Button from 'components/button';
import { getPopularReportImg } from 'utils/imageHandling';
import styled from 'styled-components';
import DateRangeFilter from './shared/DateRangeFilter';
import UsersSelectMultiple from './shared/UserSelectMultiple/UserSelectMultiple';
import { PopularReportsContext, ReportsContext } from 'contexts/reporting';
import { useContext, useState } from 'react';
import { USER_ACTIVITY } from 'constants/reporting';
import { Spin } from 'components/loadings/Spinner';
import SpinnerIMG from 'assets/images/spinner.png';

const Img = styled.img.attrs({
  loading: 'lazy',
  decoding: 'async',
  fetchpriority: 'low',
  width: 35,
  height: 35,
})`
  flex-shrink: 0;
  aspect-ratio: 1/1;
`;

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  flex-direction: column;
  .user-select__filter-container {
    width: 100%;
  }
  .ReportingFiltersComponents__DateFilter {
    width: 100%;
  }
`;

const Label = styled.span`
  padding: 10px 0;
  color: var(--light-gray-darker, #57575c);

  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  align-self: stretch;

  color: var(--black-darkest, #111a27);
  font-weight: 700;
`;

const Content = styled(ModalContent)`
  padding: 13px 15px;

  ${screenSm} {
    padding: 30px;
  }

  gap: 15px;
  display: flex;
  flex-direction: column;
`;

const ModalActionsSection = styled(ModalActions)`
  flex-direction: column-reverse;

  ${screenSm} {
    flex-direction: row;
  }
`;

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
  z-index: 100;
  pointer-events: all;
`;

const GenerateReportModal = ({ close, isOpen, report }) => {
  const { generatePopularReport, updatingPopularReport } = useContext(PopularReportsContext);
  const { refreshReports } = useContext(ReportsContext);
  const [dateFilter, setDateFilter] = useState(null);
  const [usersSelected, setUsersSelected] = useState([]);

  const onDateRangeFilterChange = (dateStart, dateEnd) => {
    setDateFilter({
      from: dateStart,
      to: dateEnd,
    });
  };
  const onUsersSelected = (selectedUsers) => {
    setUsersSelected(selectedUsers.map((user) => user.id));
  };
  const onGenerateReport = async () => {
    if (!generatePopularReport || !dateFilter?.from || !dateFilter?.to) {
      return;
    }

    const params = {
      popular_report_id: report.id,
      from_date: dateFilter.from,
      to_date: dateFilter.to,
    };
    if (report.type === USER_ACTIVITY) {
      params['uaa_ids'] = usersSelected;
    }
    const wasGenerated = await generatePopularReport(params);
    if (wasGenerated) {
      if (refreshReports) {
        await refreshReports();
      }
      close();
    }
  };
  return (
    <Modal
      visible={isOpen}
      onCancel={close}
      footer={null}
      fullscreen={isMobile}
      closeIconColor="#fff"
    >
      <ModalContainer style={updatingPopularReport ? { position: 'relative' } : undefined}>
        {updatingPopularReport && (
          <>
            <LoadingOverlay />
            <Spin src={SpinnerIMG} size="80" zIndex="120" />
          </>
        )}
        <HeaderContainer isPopularReport>
          <Title>Generate report</Title>
        </HeaderContainer>
        <Content>
          {report && (
            <Row>
              <Description>
                <Img src={getPopularReportImg(report.type)} alt="Popular Report" />
                <span>{report.name}</span>
              </Description>
            </Row>
          )}
          <Row>
            <DateRangeFilter setDates={onDateRangeFilterChange} showModalLayout={true} />
          </Row>
          {report && report.type === USER_ACTIVITY && (
            <Row>
              <Label>Filter by user(s)</Label>
              <UsersSelectMultiple onUserChange={onUsersSelected} />
            </Row>
          )}
        </Content>
        <ModalActions>
          <Button $terciary onClick={close}>
            Cancel
          </Button>
          <Button disabled={updatingPopularReport} onClick={onGenerateReport}>
            Generate report
          </Button>
        </ModalActions>
      </ModalContainer>
    </Modal>
  );
};

export default GenerateReportModal;
